module.exports = __webpack_public_path__ + "static/media/task.269825a6.svg";